import { Box } from '#/components/Box/Box';
import { InputField } from '#/components/Form/InputField';
import { SelectInputField } from '#/components/Form/SelectInputField';
import { useI18n } from '#/i18n/hooks/useI18n';
import { COUNTRIES } from '#/utils/constants/general/countries';
import { US_STATES } from '#/utils/constants/general/usStates';

export type AddressWithoutLocationFormValues = {
  country: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  zipcode: string;
};

type Props = {
  namePrefix?: string;
  useUSStateDropdown?: boolean;
};

export function AddressWithoutLocationForm({
  namePrefix,
  useUSStateDropdown,
}: Props) {
  const { i18n } = useI18n();

  // oxlint-disable-next-line typescript/no-explicit-any
  const getName = (name: any) => (namePrefix ? `${namePrefix}.${name}` : name);

  return (
    <>
      <SelectInputField
        name={getName('country')}
        label={
          /* TRANSLATORS: Form field for address country */
          `${i18n('Country')}*`
        }
        options={COUNTRIES(i18n).map(({ id, name }) => ({
          label: name,
          value: id,
        }))}
      />

      <InputField
        name={getName('line1')}
        label={
          /* TRANSLATORS: Form field for address line 1 */
          `${i18n('Address Line 1')}*`
        }
        placeholder={i18n('123 5th Street')}
      />

      <InputField
        name={getName('line2')}
        label={
          /* TRANSLATORS: Form field for address line 2 */
          i18n('Address Line 2')
        }
        placeholder={i18n('e.g., suite 201 (optional)')}
      />

      <InputField
        name={getName('city')}
        label={
          /* TRANSLATORS: Form field for address city */
          `${i18n('City')}*`
        }
        placeholder={i18n('Lake Wobegon')}
      />

      <Box display="flex" flexWrap={['wrap', 'wrap', 'wrap', 'nowrap']}>
        {useUSStateDropdown ? (
          <SelectInputField
            label={
              /* TRANSLATORS: US State */
              `${i18n('State')}*`
            }
            name="state"
            options={[
              {
                value: '',
                label: 'Select One',
                disabled: true,
              },
            ].concat(
              // @ts-expect-error TS(2769): No overload matches this call.
              US_STATES(i18n).map((state) => ({
                label: state.name,
                value: state.id,
              })),
            )}
          />
        ) : (
          <Box width={1} pr={[0, 0, 0, '8px']}>
            <InputField
              name={getName('state')}
              label={
                /* TRANSLATORS: Form field for address state/province */
                `${i18n('State/Province')}*`
              }
              placeholder={i18n('Minnesota')}
            />
          </Box>
        )}

        <Box width={1} pl={[0, 0, 0, '8px']}>
          <InputField
            name={getName('zipcode')}
            label={
              /* TRANSLATORS: Form field for address zip/postal code */
              `${i18n('Zip/Postal Code')}*`
            }
            placeholder={i18n('12345')}
          />
        </Box>
      </Box>
    </>
  );
}
